export default __webpack_public_path__ + "static/media/aimarketplace.b42c1400.jpeg";